import { Box, Tabs, Tab } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import LinkIcon from "@mui/icons-material/Link";
import ScienceIcon from "@mui/icons-material/Science";
import { SyntheticEvent, useState } from "react";
import TemplateConfiguration from "./template-configuration/template-configuration";
import TemplateAssignment from "./template-assignment/template-assignment";
import TemplateTest from "./template-test/template-test";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel = ({ children, value, index }: TabPanelProps) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`template-tabpanel-${index}`}
      aria-labelledby={`template-tab-${index}`}
    >
      {value === index && (
        <Box
          sx={{
            pt: 3,
            pb: 3,
            px: 2,
            bgcolor: "background.paper",
            borderRadius: "0 0 4px 4px",
          }}
        >
          {children}
        </Box>
      )}
    </div>
  );
};

const Templates = () => {
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (_event: SyntheticEvent, newValue: number) => {
    setCurrentTab(newValue);
  };

  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        minHeight: "600px",
        borderRadius: 1,
      }}
    >
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          bgcolor: "background.paper",
          borderRadius: "4px 4px 0 0",
          px: 2,
        }}
      >
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          aria-label="template tabs"
          sx={{
            "& .MuiTab-root": {
              minHeight: 64,
              textTransform: "none",
              fontSize: "0.9rem",
            },
          }}
        >
          <Tab
            icon={<SettingsIcon />}
            iconPosition="start"
            label="Configuration"
            id="template-tab-0"
          />
          <Tab
            icon={<LinkIcon />}
            iconPosition="start"
            label="Assignment"
            id="template-tab-1"
          />
          <Tab
            icon={<ScienceIcon />}
            iconPosition="start"
            label="Test"
            id="template-tab-2"
          />
        </Tabs>
      </Box>

      <TabPanel value={currentTab} index={0}>
        <TemplateConfiguration />
      </TabPanel>

      <TabPanel value={currentTab} index={1}>
        <TemplateAssignment />
      </TabPanel>

      <TabPanel value={currentTab} index={2}>
        <TemplateTest />
      </TabPanel>
    </Box>
  );
};

export default Templates;
